module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap11"
    }
  }, [_vm._v("ELEVEN")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE OTHER")]), _vm._v(" side of the wall Miss Remington lifted her head with a jerk.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I’m sure it’s a blessing this room doesn’t face the same way as the drawing-room.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The ladies were in their own sitting-room. It looked towards the road and had a view of wind-driven shrubs this side and rising ground beyond. There was a good deal of furniture and a great many knick-knacks. Every inch of the wall space was taken up. A number of small tables cluttered the floor. The blue plush curtains were heavy. The Brussels carpet had worn remarkably well, its harsh blues and browns being practically intact.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mrs Brand said, ‘We don’t get the sun, or the view of the sea.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Cassy tossed her head.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You don’t care for too much sun, and I’m sure the sea makes quite enough noise on this side. So does Helen Adrian. I shall speak to Felix. They really ought to keep the windows shut when they’re practising. I don’t see why we should have to close ours.’ She went quickly to the casement as she spoke and jerked it to with a bang.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Florence Brand was darning a stocking. She looked up. She allowed her eyes to rest upon her sister for a moment and then went on darning, taking a thread and leaving a thread in a slow, deliberate manner.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘People pay to hear her,’ she said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Miss Cassy turned round.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I don’t know why you have her here.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I don’t have her here. And Felix won’t much longer.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Cassy stared.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘How do you know? She’d marry him for twopence.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Florence Brand shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Oh, no—not now—not without Martin’s money.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Well, she’d be a good riddance,’ said Cassy Remington.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("As she spoke, the door, which had been slightly ajar, was pushed a little wider. Mrs Bell’s lugubrious face with the fair streaky hair coming down in loops looked round it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Emma’s doing fish for you, Mrs Brand. She’s brought it with her, but there wasn’t any haddock, so it’s cod, and a few herrings for breakfast.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She went back through and told her sister Mrs Woolley that Miss Remington had turned up her nose, but what was the good, someone had got to eat cod, and they were carrying on like nobody’s business about that Miss Adrian.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the drawing-room Felix lifted his hands from the keyboard and said,")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Not much wrong with the voice. Let’s run through that again. And try letting it out a little.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The sun streamed in through the three windows. The two double casements stood wide, but the window in the middle, which was really a door, was closed. All the curtains were a pale brocade with the colour bleached out of it. The room corresponded to Martin Brand’s study on the other side of the wall, and it looked and felt as if it had never been lived in. An ivory wallpaper with a satin stripe was here and there interrupted by watercolours with wide white mounts and narrow gold frames. The furniture was, as Penny had described it, gilt and spindly. Most of it was shrouded in dust-sheets, but the covers had been carelessly pulled off two of the larger chairs and tossed in a heap upon an Empire couch.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the midst of all this stiffness and pallor Helen Adrian looked as warmly alive as the sunshine. Her hair was very nearly as golden. Her skin glowed with health, and her eyes were just that one shade deeper than sky-blue which makes all the difference. She shook her head and said,")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No, that’s enough.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Felix jerked back the heavy lock of dark hair which was always falling into his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Just let your voice out. I believe it’s better than ever.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She was leaning over the piano towards him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No—I don’t want to.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He said accusingly, ‘You’re scared,’ and she nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I’m afraid of singing out. I don’t feel—’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You don’t need to feel. Sing! It’s all there—just let it go.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He struck the opening chords, but she remained leaning there, tracing an imaginary pattern on the dark wood and looking down at her own finger with its polished rosy nail.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Felix—’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He banged out a bar and stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘What is it?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘It’s no good. I can’t go on to a concert platform and sing in a whisper, and I’m not going to let my voice out and crack it.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘What are you driving at?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Oh, well—’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You’ve got an engagement in Brighton in a fortnight’s time. How are you going to keep it if you won’t try your voice?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Well, that’s just it—I don’t think I’m going to keep it.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘And all the rest of your engagements?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I don’t think—’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You don’t think? You’ve "), _c('i', [_vm._v("got")]), _vm._v(" to think!’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I’m not going to crack my voice.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘There’s nothing the matter with your voice.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She straightened up with a little laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Well, it "), _c('i', [_vm._v("is")]), _vm._v(" my voice, darling—I’m glad you admit that—and if I don’t want to sing, you can’t make me.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He swung round on the piano-stool.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Do you mean anything by that?’ Then, with the blood rushing into his face, ‘What do you mean?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She was watching him. Now she smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I just don’t want to sing, darling’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He got up and came towards her quite slowly and deliberately.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Do you mean now—or—’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I mean now.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘All right, then we try again tomorrow—is that it?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No, I don’t think so. Felix, do be reasonable.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The blood had drained back. The lock of hair had fallen forward again. It emphasized his pallor.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘What do you mean by being reasonable?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She laughed lightly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘It’s not anything you’d understand very well, is it, darling?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He said heavily,")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No, I’m not reasonable about you—you needn’t expect it. But you’re going to tell me what you mean.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Am I?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He said with sudden violence,")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Some day you’re going to get yourself murdered!’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Quite involuntarily she flinched. It was only Felix in a temper, but just for the moment something in her wavered and was afraid.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She stepped back, and the movement brought the door into her line of vision. The ivory panels, the china handle and door-plates with their pattern of small pink roses, stood very slightly at an angle. The door was not quite shut. She went over to it, opened it, and looked out. A yard away Mrs Bell was on her hands and knees in the passage polishing the floor-boards.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Helen Adrian shut the door in a controlled manner and went back. Felix was still in a temper, but he didn’t frighten her now. She stuck her chin in the air and said,")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Next time you feel like murdering anyone, darling, I don’t think I should tell the daily first.’ Then, with a laugh, ‘Oh, come off it, Felix! Let’s go down and see if it’s warm enough to bathe.’")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ada2212","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/14-chap11.vue
// module id = 111
// module chunks = 0